export default __webpack_public_path__ + "static/media/errorDesktopIcon.a393bf1c.svg";